<h2 mat-dialog-title><mat-icon>info</mat-icon></h2>
<mat-dialog-content class="mat-typography">
    <p>{{textToAgree}}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial><mat-icon>check</mat-icon></button>
  </mat-dialog-actions>
  